export enum Consumer {
  DRIVE = 'drive',
  ERROR_PAGE = 'error-page',
  FLP = 'flp',
  GUIDE_TO_BUYING_EV = 'guide-to-buying-ev',
  HOME = 'home',
  HOMEWEBVIEW = 'home-webview',
  NEW_CARS = 'new-cars',
  SHAQVANA = 'shaqvana',
  SRP = 'srp',
  VDP = 'vdp',
  VENDING_MACHINE = 'vending-machine',
  WHAT_TO_EXPECT = 'what-to-expect'
}
